import React from "react";
import { Route, Redirect } from "react-router-dom";
import Home from "../containers/home/Home";

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default ({ component: C, props: cProps, ...rest }) => {
  const redirect = querystring("redirect");
  // let mcu_key = JSON.parse(import.meta.env.VITE_isOffline) ? 'mcuServer' : 'custom:mcuServer';
  // <Redirect
  //             to={redirect === "" || redirect === null ? validateSetup(cProps.userPayload[mcu_key]) : validateActions(redirect, cProps)}
  //           />}

  // console.log("search ==== ", cProps, rest);
  // console.log("redirect unauth page ===========", redirect);
  return (
    <Route
      {...rest}
      render={(props) =>
        !cProps.isAuthenticated ? (
          <Home
            {...props}
            {...cProps}
            component={(props) => <C {...cProps} {...props} />}
          />
        ) : (
          <Redirect
            // to={
            //   redirect === "" || redirect === null
            //     ? "/dashboard"
            //     : `/${props.location.search}`
            // }
            to={redirect === "" || redirect === null ? "/dashboard" : redirect}
          />
        )
      }
    />
  );
};

//<C {...props} {...cProps} />

//component={C}
